import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeletePaymentMethod(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deletePaymentMethod = (paymentMethodId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`payment-methods/${paymentMethodId}/`);
  };

  return useMutation(deletePaymentMethod, {
    onSuccess: (_, paymentMethodId) => {
      queryClient.invalidateQueries({
        predicate: query => query.queryKey[0] === 'paymentMethods' && query.queryKey[1] !== paymentMethodId,
      });
    },
  });
}
